import { render } from "./SubmitPurchase.vue?vue&type=template&id=5c8c4ab1&ts=true"
import script from "./SubmitPurchase.vue?vue&type=script&lang=ts"
export * from "./SubmitPurchase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__